import { Layout } from 'antd'
import React from 'react'
import EmailVerification from '../../components/EmailVerification';

const EmailVerificationPage = (props) => {
    return (
        <Layout>
            <Layout.Content >
                <EmailVerification token={props.match.params.token} />
            </Layout.Content>
        </Layout>
    )
}

export default EmailVerificationPage
